<template>

  <div>

    <div class="container flex justify-center editor">

        <div class="">
          <h2>Expediente e Intervalos</h2>
          <p> Temos dois horários de expediente: </p>
          <ul>
            <li>de 8h às 18h (2 horas de almoço)</li>
            <li>de 9h às 18h</li>
          </ul>
          <p>
            Intervalo:
          </p>
          <ul>
            <li>de 16h às 16h20</li>
          </ul>

          <p class="flex" style="font-size: 14px; color: #a2a2a2">
            <img src="@/assets/images/integracao/alerta.svg" width="50px" alt="" class="mr-2">Atrasos deverão ser comunicados com antecedência ao líder de equipe e <br> ao Departamento de Gestão de
            Pessoas.</p>

          <h2>Calendário de Atividades Organizacionais</h2>

          <img src="@/assets/images/integracao/calendario.png" class="mt-3 calendario responsive">
          <p style="font-size: 14px; color: #a2a2a2">
            * Toda última sexta-feira do mês, a WDC promove um Happy Hour à partir das 17h.
          </p>
        </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "Diferenciais",
  props: [],
  created() {},
  data() {
    return {
      pronome: "a",
      animation_path: [],
      width: window.innerWidth,
      popupActive: false,
    };
  },
  methods: {
    next(step) {
      this.$store.dispatch("integracao/setStep", step).then(() => {
        this.$router.push({
          name: "integracao-" + this.$store.state.integracao.page,
        });
      });
    },
  },
  watch: {
    windowWidth() {
      this.width = window.innerWidth;
    },
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
};
</script>

<style scoped>
  header{
        
  }
  ul li::before {
  content: "•";
  color: #00A3B4;
  font-size: 30px;
  font-weight: bold;
  display: inline-block; 
  width: 0.6em;
}
</style>
